import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface IFetchGoogleSearchPlaceOutput {
  formatted_address: string;
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
  };
  name: string;
}

export interface IFetchGoogleSearchPlaceInput {
  keyword: string;
}

export const fetchGoogleSearchPlace = async (
  payload: IFetchGoogleSearchPlaceInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/google/search-place?keyword=${payload.keyword}`
  );

  let _data: IFetchGoogleSearchPlaceOutput[] = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
